export default __webpack_public_path__ + "static/media/pic15.d5e90468.jpg";